import {createLazyResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {ApplicationModel} from '../../../models/api/applicationModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, LazyResourceTable, ResourceTableStatusesEnum} from '../../appTypes';
import {PushStatusActionsEnum} from '../../pushStatus/pushStatusActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {ApplicationsActionsEnum} from './applicationsActions';

const applicationsUpdatedReducer = createLazyResourceTableUpdatedReducer(
  'applications',
  (application) => application.id,
);

export function applicationsReducer(
  state: LazyResourceTable<number, ApplicationModel>,
  action: AppAction,
): LazyResourceTable<number, ApplicationModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return applicationsUpdatedReducer(state, action);

    // When live updates is disconnected we should mark the store as stale so we will
    // refresh when they reconnect.
    case PushStatusActionsEnum.PUSH_DISCONNECTED:
      return {
        ...state,
        isStale: true,
      };

    case ApplicationsActionsEnum.FETCH_APPLICATIONS:
      return {
        ...state,
        status: ResourceTableStatusesEnum.LOADING,
        error: undefined,
      };

    case ApplicationsActionsEnum.FETCH_APPLICATIONS_COMPLETED:
      return {
        ...applicationsUpdatedReducer(state, {
          ...action,
          payload: {
            result: {
              applications: action.payload,
            },
          },
        }),
        status: ResourceTableStatusesEnum.LOADED,
        error: undefined,
        isStale: false,
      };

    case ApplicationsActionsEnum.FETCH_APPLICATIONS_FAILED:
      return {
        ...state,
        status: ResourceTableStatusesEnum.FAILED,
      };

    case ApplicationsActionsEnum.APPLICATION_UPDATED:
      return applicationsUpdatedReducer(state, {
        ...action,
        payload: {
          result: {
            applications: [action.payload],
          },
        },
      });

    case ApplicationsActionsEnum.APPLICATION_DELETED:
      return deleteFromResourceTable(state, action.payload);

    default:
      return state;
  }
}
